import * as go from 'gojs'

// Based on https://gojs.net/latest/extensions/DrawCommandHandler.js

function TdsCommandHandler () {
  go.CommandHandler.call(this)
  this._pasteOffset = new go.Point(10, 10)
  this._lastPasteOffset = new go.Point(0, 0)
}
go.Diagram.inherit(TdsCommandHandler, go.CommandHandler)

TdsCommandHandler.prototype.copyToClipboard = function (coll) {
  go.CommandHandler.prototype.copyToClipboard.call(this, coll)
  this._lastPasteOffset.set(this.pasteOffset)
}

TdsCommandHandler.prototype.pasteFromClipboard = function () {
  var coll = go.CommandHandler.prototype.pasteFromClipboard.call(this)
  this.diagram.moveParts(coll, this._lastPasteOffset)
  this._lastPasteOffset.add(this.pasteOffset)
  return coll
}

Object.defineProperty(TdsCommandHandler.prototype, 'pasteOffset', {
  get: function () { return this._pasteOffset },
  set: function (val) {
    if (!(val instanceof go.Point)) throw new Error('TdsCommandHandler.pasteOffset must be a Point, not: ' + val)
    this._pasteOffset.set(val)
  }
})

export { TdsCommandHandler }



// WEBPACK FOOTER //
// ./src/graph_parts/tds_command_handler.js